import React, { useState } from 'react';
import {Grid, TextField, Typography, Button, Box, Alert} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {resendOtp, verifyOtp} from "../index";
import { Link as LinkUI, useNavigate } from "react-router-dom";

const Link = styled(LinkUI)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.dark,
    },
}));

export const VerifyOtp = ({redirectTo}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state) => state.auth?.user);

    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("info");
    const [errors, setErrors] = useState({});
    const [otp, setOtp] = useState('');

    const handleChange = (e) => {
        const {name, value} = e.target;
        setErrors(prevErrors => ({
            ...prevErrors,
            [name]: null,
        }));
        setOtp(value);
    }

    const handleSubmit = async () => {
        if (!user?.id) {
            setMessage('Missing user context. Start again from Forgot password or Register.');
            setErrors({});
            setStatus('error');
            return;
        }
        const res = await verifyOtp({ dispatch, data: { id: user.id, otp } });

        if(res['success']){
            setOtp('');
            navigate(redirectTo);
        }
        setMessage(res.message);
        setErrors(res.errors);
        setStatus(res.status);
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleResendOTP = async () => {
        const email = user?.email;
        if (!email) {
            setMessage('Unable to resend: email context is missing. Start again from Forgot password.');
            setStatus('warning');
            return;
        }
        const res = await resendOtp({ dispatch, data: { email } });
        setMessage(res.message);
        setErrors(res.errors);
        setStatus(res.status);
        if (res.success) {
            setOtp('');
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography align={"center"} mb={4} fontWeight={"bold"} className={"title"} variant={"h1"}>Verify OTP</Typography>
                <Typography align={"center"} mb={4} variant={"body1"}>Enter the OTP sent to your email</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    {message && (
                        <Grid item xs={12}>
                            <Alert severity={status}>{message}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            value={otp}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            id="otp"
                            name="otp"
                            label="OTP"
                            fullWidth
                            error={!!errors?.otp}
                            helperText={errors?.otp}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            fullWidth={true}
                            variant="contained"
                            disableElevation={true}
                            onClick={handleSubmit}
                            size="large"
                            sx={{height: 50, fontSize: 18, textTransform:"capitalize"}}
                        >
                            Verify
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Typography variant="body2" component="div">
                                {"Didn't receive the OTP? "}
                                <Typography component="span" variant="body2" onClick={handleResendOTP} sx={{ cursor: 'pointer', textDecoration: 'underline' }}>
                                    Resend OTP
                                </Typography>
                            </Typography>
                            <Typography variant={"body2"} sx={{ mt: 1.5 }}>Remembered your password? <Link to="/login">Login</Link></Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
